// Do not modify this file by hand!
// Re-generate this file by running lit-localize.

/**
 * The locale code that templates in this source code are written in.
 */
export const sourceLocale = `en-GB`;

/**
 * The other locale codes that this application is localized into. Sorted
 * lexicographically.
 */
export const targetLocales = [
  `de-DE`,
  `es-ES`,
  `fr-FR`,
  `it-IT`,
  `pt-PT`,
] as const;

/**
 * All valid project locale codes. Sorted lexicographically.
 */
export const allLocales = [
  `de-DE`,
  `en-GB`,
  `es-ES`,
  `fr-FR`,
  `it-IT`,
  `pt-PT`,
] as const;
